import { Card } from 'external/react'

import HomeItem from 'components/HomeItem'

const HomePage = () => {
	return (
            <Card.Body className='mt-2'>
               <div className="row mt-3 mb-3 justify-content-center">
                    {/*
                    <HomeItem className='mr-3' icon='faBox' label='Ofertas' to={'/admin/offers'}>
                        <div className='text-muted mb-0'><span className='text-white'>.</span></div>
                    </HomeItem>
                    <HomeItem className='mr-3' icon='faHandHoldingDollar' label='Pagos' to='/admin/transactions'>
                        <div className='text-muted mb-0'><span className='text-white'>.</span></div>
                    </HomeItem>
                    */}
                    <HomeItem className='mr-3' icon='faUsers' label='Clientes' to='/admin/clients'>
                        <div className='text-muted mb-0'><span className='text-white'>.</span></div>
                    </HomeItem>

                </div>
            </Card.Body>
	)
}

export default HomePage